module.exports = __webpack_public_path__ + "static/loading-807a3fcbdf421e9c8db810f38c9273da.gif";